export default __webpack_public_path__ + "static/media/english-to-romanian-logo.59d23ba4.png";